import styled from 'styled-components';

type BadgeProps = {
  borderColor?: string;
  textColor?: string;
  backgroundColor?: string;
  children: React.ReactNode;
};

export default function Badge(props: BadgeProps) {
  return <BadgeContainer {...props}>{props.children}</BadgeContainer>;
}

const BadgeContainer = styled.div<{
  textColor?: string;
  borderColor?: string;
  backgroundColor?: string;
}>`
  background-color: ${(props) => props.backgroundColor || 'none'};
  color: ${(props) => props.textColor || 'inherit'};
  padding: 2px 8px;
  width: fit-content;
  border: ${(props) =>
    props.borderColor ? `1px solid ${props.borderColor}` : 'none'};
  border-radius: 4px;
  height: 16px;
  display: flex;
  gap: 8px;
  align-items: center;
  margin: 0px;
  font-family: Inter;
  font-size: 12px;
  font-style: normal;
  line-height: normal;
  text-transform: uppercase;
`;
